import Sports from "./subOptions/Sports";
import Personal from "./subOptions/Personal";
import Goals from "./subOptions/Goals";
import Introvert from "./subOptions/Introvert";
import { Fragment } from "react";

const Options = ({ options, handleUserChange, userData, onUpload }) => {
  const optionsArray = [
    [<Introvert handleUserChange={handleUserChange} userData={userData} />],
    [<Sports handleUserChange={handleUserChange} userData={userData} />],
    [<Personal handleUserChange={handleUserChange} userData={userData} />],
    [<Goals handleUserChange={handleUserChange} userData={userData} onUpload={onUpload} />],
  ];
  return (
    <>
      {/* Now lets render ONE page at a time */}
      {optionsArray[options].map((page, index) => (
        <Fragment key={index}>{page}</Fragment>
      ))}
    </>
  );
};

export default Options;
